import { ProcessingTimeSpec } from './processing-time-spec'

export class ProcessingTimeUtils {
  public static update(source: ProcessingTimeSpec, target: ProcessingTimeSpec): void {
    target.id = source.id
    target.propertyId = source.propertyId
    target.property = source.property
    target.unit = source.unit
    target.description = source.description
    target.setNumber = source.setNumber
  }
}
